export const CLAUDE_CONNECTOR_URL = "https://claude.ai/new#customize/connectors/id/runplutus";

export const CLAUDE_CONNECTOR_TOPICS = {
  dashboard: "your account, allocations, or performance",
  positions: "your holdings, exposure, or account",
  analyze: "your portfolio analysis, performance, or reporting",
  setup: "any portfolio, your account, or reporting",
  discover: "any portfolio, basket, or your account",
  product: "this portfolio, its holdings, or performance",
  basket: "this basket, its holdings, or performance",
  settings: "your account, Plutus data, or reporting",
  "share-in": "this portfolio, its holdings, or performance",
  "share-out": "this portfolio or the Plutus data available to you",
} as const;

export type ClaudeConnectorContext = keyof typeof CLAUDE_CONNECTOR_TOPICS;
export type ClaudeProductKind = "portfolio" | "basket";

export function getClaudeConnectorContext(pathname: string): ClaudeConnectorContext | null {
  const path = pathname.toLowerCase().replace(/\/+$/, "");
  if (path === "/alpha/dashboard" || path === "/alpha/setupv2/dashboard") return "dashboard";
  if (path === "/alpha/positions" || path === "/alpha/positions/v3") return "positions";
  if (path === "/alpha/analyze" || path === "/alpha/analyze/dev-preview") return "analyze";
  if (path === "/alpha/profile") return "settings";
  if (path === "/alpha/discover") return "discover";
  if (/^\/alpha\/discover\/(portfolio|basket)\/[^/]+\/[^/]+$/.test(path)) {
    return path.startsWith("/alpha/discover/basket/") ? "basket" : "product";
  }
  if (path === "/alpha/setupv2" || path.startsWith("/alpha/setupv2/")) return "setup";
  return null;
}
